export function installErrorHandler(appsignal, application) {
  var prevHandler = application.handleError;
  application.handleError = function (error, message) {
    var span = appsignal.createSpan(function (span) {
      return span.setTags({
        framework: "Stimulus",
        message: message
      }).setError(error);
    });
    appsignal.send(span);
    if (prevHandler && typeof prevHandler === "function") {
      prevHandler.apply(this, arguments);
    }
  };
}